module.exports = __webpack_public_path__ + "img/bg-home-desktop.b48aed95.png";